var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$vuetify.breakpoint.xsOnly)?_c('XsRewards'):_c('div',[_c('RewardsPoints'),_c('RewardsClubs')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }